import type { Service } from '~publish/contexts/AccountContext/graphqlEnums'

type EmptyStateFeature = 'calendar' | 'queue'

export function trackQueueOpened(organizationId: string): void {
  window.analytics?.track('Queue Opened', {
    organizationId,
    clientName: 'publishWeb',
    product: 'publish',
  })
}

export function trackEmptyStateClicked({
  organizationId,
  feature,
  channel,
}: {
  organizationId: string
  feature: EmptyStateFeature
  channel: Service
}): void {
  window.analytics?.track('Empty State Clicked', {
    organizationId,
    clientName: 'publishWeb',
    product: 'publish',
    feature,
    channel,
  })
}
